import { authService as baseAuth } from '@platzona/auth-client';

export const authService = {
  ...baseAuth,
  isAdmin(): boolean {
    const u = this.getUser();
    return Array.isArray(u?.roles) && (u.roles.includes('admin') || u.roles.includes('super_admin'));
  },
  /** Global user management (/api/auth/admin/users) requires super_admin specifically —
   * a plain platform "admin" can see this page but must not see or hit that section. */
  isSuperAdmin(): boolean {
    const u = this.getUser();
    return Array.isArray(u?.roles) && u.roles.includes('super_admin');
  },
};
